import Nav from "../components/Nav";
import Hero from "../components/Hero";
import ValueProposition from "../components/ValueProposition";
import Problem from "../components/Problem";
import Solution from "../components/Solution";
import Mechanism from "../components/Mechanism";
import WhoFor from "../components/WhoFor";
import Proof from "../components/Proof";
import HowItWorks from "../components/HowItWorks";
import FAQ from "../components/FAQ";
import Apply from "../components/Apply";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#0D0E12] text-[#F4EFE6] font-body antialiased">
      <div className="grain-overlay" />
      <Nav />
      <main data-testid="main-content">
        <Hero />
        <ValueProposition />
        <Problem />
        <Solution />
        <Mechanism />
        <WhoFor />
        <Proof />
        <HowItWorks />
        <FAQ />
        <Apply />
      </main>
      <Footer />
    </div>
  );
}
